import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { get, capitalize } from 'lodash'
import { adminBeneficiaryVettingDemographicList } from './actions/admin_beneficiary_vetting_demographic'
import { showSuccess } from 'actions/Error'
import { handleSubmitResult } from 'actions/form'
import AdminCommonForm from '../layout/AdminCommonForm'
import AdminBeneficiaryVettingDemographicForm, { validationSchema } from './form/AdminBeneficiaryVettingDemographicForm'
import { FormikGeneralFormErrors } from 'components/form/GeneralFormErrors'

const getDefaultInitialValues = () => ({
  age_group: '',
  sex: '',
  race: '',
  number_of_people: ''
})

export default function AdminBeneficiaryVettingDemographic({
  in_modal = false,
  onClose = () => {},
  passed_demographic_id = null,
  beneficiary_vetting_id = null
}) {
  const dispatch = useDispatch()
  const demographic_id = passed_demographic_id
  const demographic = useSelector(() => adminBeneficiaryVettingDemographicList.getObject(demographic_id))
  const initial_values = demographic && get(demographic, 'id') ? demographic : getDefaultInitialValues()
  const is_loading = useSelector(() => adminBeneficiaryVettingDemographicList.isLoading()) ||
    (demographic_id && !get(demographic, 'id'))
  const is_busy = useSelector(() => adminBeneficiaryVettingDemographicList.getIsSavingObject())
  const title =
    demographic && get(demographic, 'id')
      ? `${capitalize(get(demographic, 'race', ''))}, ${capitalize(get(demographic, 'sex', ''))}, ${capitalize(get(demographic, 'age_group', ''))}`
      : 'New Demographic'

  useEffect(() => {
    if (demographic_id) {
      dispatch(adminBeneficiaryVettingDemographicList.ensureObjectLoaded(demographic_id))
    }
  }, [dispatch, demographic_id])

  const onSave = (values, formik_funcs) => {
    const payload = { ...values }
    if (beneficiary_vetting_id) {
      payload.beneficiary_vetting = beneficiary_vetting_id
    }
    const raw = payload.number_of_people
    const n = raw === '' || raw == null ? 0 : Number(raw)
    payload.number_of_people = Number.isInteger(n) ? n : Math.floor(Number(n)) || 0
    const on_ok = function (json) {
      dispatch(adminBeneficiaryVettingDemographicList.invalidateList())
      showSuccess('Saved', 'Demographic saved')
      if (in_modal) onClose()
    }
    if (demographic_id) {
      payload.id = demographic_id
      return dispatch(adminBeneficiaryVettingDemographicList.saveObject(payload)).then((res) =>
        handleSubmitResult({ res, formik_funcs, on_ok })
      )
    }
    return dispatch(adminBeneficiaryVettingDemographicList.saveNewObject(payload)).then((res) =>
      handleSubmitResult({ res, formik_funcs, on_ok })
    )
  }

  if (!in_modal) return null

  return (
    <AdminCommonForm
      is_loading={is_loading}
      is_busy={is_busy}
      initial_values={initial_values}
      inModal={true}
      onSave={onSave}
    >
      {({ formik_props }) => (
        <>
          <FormikGeneralFormErrors render={(msg) => msg} name={undefined} />
          <AdminBeneficiaryVettingDemographicForm formik_props={formik_props} />
        </>
      )}
    </AdminCommonForm>
  )
}
